import { render, staticRenderFns } from "./ElementData.vue?vue&type=template&id=1edf8908&scoped=true&"
import script from "./ElementData.vue?vue&type=script&lang=js&"
export * from "./ElementData.vue?vue&type=script&lang=js&"
import style0 from "./ElementData.vue?vue&type=style&index=0&id=1edf8908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edf8908",
  null
  
)

export default component.exports